export default () => {
    window.addEventListener('scroll', function () {
        const mainHeader = document.querySelector('#header');
        const wrapper = document.querySelector('div.header-wrapper');
        if (wrapper.classList.contains('stuck')) {
            const filteringElement = document.querySelector('.category-filtering');
            if (filteringElement) {
                const height = document.getElementById('masthead').offsetHeight;
                let scrollPosition = document.documentElement.scrollTop;

                if (scrollPosition > mainHeader.offsetHeight) {
                    filteringElement.style.position = 'fixed';
                    filteringElement.style.top = height + 'px';
                    filteringElement.classList.add('filter-scrolled')
                } else {
                    filteringElement.style.position = '';
                    filteringElement.style.top = '';
                    filteringElement.classList.remove('filter-scrolled')
                }
            }
        }
    });
}